import { render } from "./LogoutMenu.vue?vue&type=template&id=79d6b5f6"
import script from "./LogoutMenu.vue?vue&type=script&lang=js"
export * from "./LogoutMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__